import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { abbreviateNumber } from 'js-abbreviation-number'
import { ShieldCheck } from 'lucide-react'
import { cn } from '@global/utils/tailwind'
import { Loader } from 'components/v2/loader'

export function OverallCompliance({ submissionsData, isLoading }) {
  const { totalComplete, totalErrors } = submissionsData

  const compliance =
    totalComplete > 0 ? Math.trunc(100 - (100 * totalErrors) / (totalComplete + totalErrors)) : 0
  const hexSVG = compliance < 80 ? '#E41B0C' : compliance < 90 ? ' #F3B03E' : '#4AA97E'
  const totalErrorNumber = abbreviateNumber(totalErrors)

  return (
    <section className="flex">
      {isLoading ? (
        <div className="border rounded-md mr-[50px] px-[15px] py-[20px] min-w-[230px] flex items-center flex-col">
          <Loader className="w-7 h-7" />
        </div>
      ) : (
        <div
          className={cn(
            'border rounded-md mr-[50px] px-[15px] py-[20px] min-w-[230px] flex items-center flex-col',
            compliance < 80
              ? 'bg-[hsla(8,95%,59%,0.12)] border-[#E41B0C] text-[#E41B0C]'
              : compliance < 90
                ? 'bg-[hsla(38,88%,60%,0.12)] border-[#F3B03E] text-[#F3B03E]'
                : 'bg-[hsla(153,57%,60%,0.12)] border-[#4AA97E] text-[#4AA97E]',
          )}
        >
          <h2 className="text-[20px] text-cv-blue-700 font-black text-center">
            {t`Data standard score`}
          </h2>
          <p
            className={cn(
              'flex items-center',
              compliance < 80
                ? 'text-[#E41B0C]'
                : compliance < 90
                  ? ' text-[#F3B03E]'
                  : 'text-[#4AA97E]',
            )}
          >
            <ShieldCheck size={36} className="mr-[10px]" color={hexSVG} />
            <span className="text-[28px] font-extrabold">{compliance}%</span>
          </p>
        </div>
      )}

      <div className="flex items-center text-[20px] text-cv-blue-700">
        <p className="leading-[32px]">
          <Trans>Your current data standard score is </Trans>
          <strong>{isLoading ? <Loader className="inline mx-3" /> : `${compliance}%`}</strong>.{' '}
          {totalErrors > 0 && (
            <Trans>
              To reach 100%, review and correct the{' '}
              <span className="text-[#E41B0C] font-bold">{totalErrorNumber} errored rows</span>
              .{' '}
            </Trans>
          )}
          <Trans>
            Use the insights below to see which templates, submissions, and rows most impact your
            score and take action.
          </Trans>
        </p>
      </div>
    </section>
  )
}
